import React, { useEffect, useState } from 'react';
import { forNotoEmoji, parseClue, toDisplayClue } from './clueUtils';
import { fetchIconUrl } from '../../services/wordInfoService';

const CustomIcon = ({ name }) => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let live = true;
    fetchIconUrl(name).then(u => live && setUrl(u));
    return () => { live = false; };
  }, [name]);

  return url ? <img src={url} alt={name} /> : <span className="glyph-placeholder" aria-hidden="true" />;
};

// Compact inline rendering of a clue for suggestion chips: the icons with their
// quotes and modifier for icon clues, plain text (soft hyphens hidden) otherwise.
const ClueGlyph = ({ clue }) => {
  const parsed = parseClue(clue);

  if (parsed.type !== 'icons') {
    return <span className="glyph-text">{toDisplayClue(clue)}</span>;
  }

  const names = parsed.glyphs.filter(g => g.type !== 'emoji').map(g => g.content).join(', ');
  return (
    <span className="glyph-icon" title={names || undefined}>
      {parsed.quoted && <span className="glyph-quote">”</span>}
      {parsed.glyphs.map((g, i) => (
        <React.Fragment key={i}>
          {g.type === 'symbol' && <span className="material-symbols-rounded">{g.content}</span>}
          {g.type === 'emoji' && <span className="glyph-emoji">{forNotoEmoji(g.content)}</span>}
          {g.type === 'custom' && <CustomIcon name={g.content} />}
        </React.Fragment>
      ))}
      {parsed.quoted && <span className="glyph-quote">”</span>}
      {parsed.modifier && <span className="glyph-mod">{parsed.modifier}</span>}
    </span>
  );
};

export default ClueGlyph;
